import type { FaireProductEntity } from "../../entity_types/product";

export const p_2cdr53t: FaireProductEntity = {
  token: "p_2cdr53t",
  type: "product",
  name: "Gochujang Red Pepper Paste",
  brandName: "Potluck",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/250be527103d99a45fd96e39a5663c9d442b0a7f4f8bd1b343c6ecde7e011a37.png",
  priceDollars: 10.5,
  description:
    "Traditional Korean fermented red chili paste. Sweet, spicy, and umami-rich.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["korean", "paste", "condiment", "premium"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/6edcc1e721d6c6e418cb5378f3f92caca5f10171ea43c6c3da92e2bc6f9da5b1.webp",
  weight: 1,
  dimensions: {
    width: 3,
    height: 5,
    depth: 3,
  },
  inStock: true,
};
